exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".contenedorTotal[data-v-335a1409]{padding:0;background-color:#fff}.borderF[data-v-335a1409]{border:1px solid #dcdcdc;margin:1%;padding:1%}.card-deck[data-v-335a1409]{padding-bottom:15px}.card2[data-v-335a1409]{box-shadow:1px 5px 7px 5px rgba(0,0,0,.1);margin-top:15px;padding-top:39px;border-color:15px gray}.card-header[data-v-335a1409]{background-color:#4db35a;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-335a1409","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/componentes/resultadotraza.vue
// module id = 487
// module chunks = 0